import { Flex, Switch, Text, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SuitabilityTextWithTooltip } from './SuitabilityTextWithTooltip';

type SelectedSwitchRowProps = {
  selectedCount: number;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function SelectedSwitchRow({ selectedCount, checked, onChange }: SelectedSwitchRowProps) {
  const theme = useMantineTheme();
  const showSwitch = selectedCount > 0;

  return (
    <Flex
      align="center"
      px="md"
      py="xxs"
      gap="xs"
      bg="orange.1"
      style={{
        borderRadius: 12,
      }}
    >
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {selectedCount} selected
      </Text>

      {showSwitch && <IconChevronRight size={16} color={theme.colors.gray[10]} />}

      {showSwitch && (
        <>
          <Switch
            checked={checked}
            onChange={e => onChange(e.currentTarget.checked)}
            color="brand"
            styles={{ root: { alignItems: 'center' } }}
          />
          <Text size="sm" fw={FONT_WEIGHTS.medium}>
            <SuitabilityTextWithTooltip tooltip="Optimise wording to minimise repetition, add context from data on the platform and help with readability.">
              Optimise the wording
            </SuitabilityTextWithTooltip>{' '}
            <Text component="span" c="gray.10">
              of the advice
            </Text>
          </Text>
        </>
      )}
    </Flex>
  );
}
